<template>
  <div class="tw-relative tw-flex tw-items-center">
    <input
      ref="flatpickr"
      v-focus="focus"
      :value="modelValue"
      class="sf-form-input sf-full-width"
      v-bind="$attrs"
      type="text"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="handleValueUpdates"
    />
    <span
      v-if="icon"
      class="
        tw-absolute tw-right-2 tw-flex tw-items-center tw-pointer-events-none
        fa fa-calendar
      "
    />
  </div>
</template>

<script>
import Flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'
import 'flatpickr/dist/flatpickr.css'

export default {
  inheritAttrs: false,
  props: {
    options: Object,
    name: String,
    placeholder: String,
    focus: Boolean,
    disabled: Boolean,
    modelValue: String,
    icon: Boolean,
    customClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],

  data() {
    return {
      defaultOptions: {
        allowInput: true,
        dateFormat: 'd/m/Y',
      },
      flatpickr: null,
    }
  },

  computed: {
    currentUserLocale() {
      switch (window.Silverfin.currentUserLocale()) {
        case 'fr':
          return French
        case 'en':
          return null
        case 'nl':
        default:
          return Dutch
      }
    },

    flatpickrOptions() {
      return Object.assign(
        { locale: this.currentUserLocale },
        this.defaultOptions,
        this.options
      )
    },
  },

  watch: {
    modelValue(newValue) {
      this.flatpickr.setDate(newValue)
    },
  },

  mounted() {
    this.flatpickr = new Flatpickr(this.$refs.flatpickr, this.flatpickrOptions)
    if (this.focus) {
      this.flatpickr.open()
    }
  },

  beforeUnmount() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
      this.flatpickr = null
    }
  },

  methods: {
    handleValueUpdates(e) {
      this.$emit('update:modelValue', e.target.value)
    },
  },
}
</script>
